import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Herologos from "./herologos"
import Img from "gatsby-image"
import { OutboundLink } from "gatsby-plugin-google-analytics"

export default function Hero() {
  const data = useStaticQuery(graphql`
    query HeroQuery {
      prismicHomepage {
        data {
          hero_image {
            fluid {
              ...GatsbyPrismicImageFluid_noBase64
            }
          }
          hero_paragraph {
            text
          }
          schedule_cta {
            text
          }
        }
      }
    }
  `)
  const heroParagraph = data.prismicHomepage.data["hero_paragraph"].text
  const scheduleCta = data.prismicHomepage.data["schedule_cta"].text
  const heroImage = data.prismicHomepage.data["hero_image"].fluid
  

  return (
    <div>
      <div className="flex flex-col max-w-6xl mx-auto mb-12 md:mb-32 px-6 lg:px-8">
        <div className="flex flex-col md:flex-row mt-4 items-center">
          <div className="text-blue-dark flex flex-col mr-0 md:mr-16">
            <div className="md:-mt-4">
              <h1 className="text-4xl text-center md:text-left md:text-4xl  lg:text-6xl mb-2 md:mb-3 max-w-lg mx-auto md:max-w-2xl font-light ">
              The best <span className="text-4xl lg:text-6xl font-bold">digital banking</span> experience from end to end.
              </h1>
              <p className="max-w-lg mx-auto mb-8 md:mb-16 md:mx-0 text-base text-blue-dark font-normal text-center md:text-left">
                {heroParagraph}
              </p>
            </div>
            <div className=" pb-4 md:self-stretch">
              <div className="hidden md:flex -ml-1 justify-center md:justify-start">
                <OutboundLink
                  rel="noopener nofollow"
                  target="_blank"
                  href="https://webforms.pipedrive.com/f/1Aj12jymq2lWRkoDMIk5EWpvZZ4H0lnoDDVX6kMxk9vrga8Y72OJLtEEYuuChGw5Z"
                  className="hoverShadow text-base font-medium pb-3 pt-2 mr-6 px-7 bg-blue text-white rounded-full"
                >
                  {scheduleCta}
                </OutboundLink>
              </div>
            </div>
          </div>
          <div className="w-full md:w-2/5 self-center md:-mt-4">
            <Img fluid={heroImage}/>
          </div>
          <div className="my-6 md:hidden flex -ml-1 justify-center md:justify-start">
            <OutboundLink
              rel="noopener nofollow"
              target="_blank"
              href="https://webforms.pipedrive.com/f/1Aj12jymq2lWRkoDMIk5EWpvZZ4H0lnoDDVX6kMxk9vrga8Y72OJLtEEYuuChGw5Z"
              className="hoverShadow text-base font-medium pb-3 pt-2 ml-4 px-7 bg-blue text-white rounded-full"
            >
              {scheduleCta}
            </OutboundLink>
          </div>
        </div>
        <Herologos />
      </div>
    </div>
  )
}
